import { useInView } from 'react-intersection-observer';
import { ANIMATION_CONFIG } from '../config/constants';

/**
 * フェードインアニメーション用のカスタムフック
 * @param {Object} options - useInViewのオプション
 * @returns {[ref, inView]} - refとinViewのタプル
 */
export const useInViewAnimation = (options = {}) => {
  const defaultOptions = {
    triggerOnce: true,
    threshold: ANIMATION_CONFIG.FADE_IN_THRESHOLD,
    rootMargin: ANIMATION_CONFIG.FADE_IN_ROOT_MARGIN,
  };

  return useInView({ ...defaultOptions, ...options });
};

/**
 * セクション用のフェードインアニメーション
 * @param {Object} options - カスタマイズオプション
 * @returns {[ref, inView]} - refとinViewのタプル
 */
export const useSectionAnimation = (options = {}) => {
  return useInViewAnimation({
    threshold: 0.1,
    rootMargin: '0px 0px -10% 0px',
    ...options,
  });
};
